import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import reject from '@material-ui/core/colors/red';
import accept from '@material-ui/core/colors/lightGreen';
import ProgressiveButton from 'components/Button/ProgressiveButton';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
  },
  accept: {
    marginRight: theme.spacing(1),
    background: accept[500],
    color: 'white',
    '&:hover': {
      background: accept[600],
    },
  },
  reject: {
    background: reject[500],
    color: 'white',
    '&:hover': {
      background: reject[600],
    },
  },
}));

export default React.memo(function AlertDialog({
  text,
  title,
  onClose,
  yes = 'بله',
  no = 'خیر',
  children,
  fullWidth = true,
  variant = 'contained',
  open = true,
  inProgress = false,
  loadingButton = false,
  isFullScreen = false,
  ...rest
}) {
  const [fullScreen, setFullScreen] = useState(false);

  const handleClose = (agree = true) => {
    onClose(agree);
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={() => handleClose(false)}
      fullWidth={fullWidth}
      {...rest}
    >
      {title ? <DialogTitle>{title}</DialogTitle> : null}
      {children ? (
        <DialogContent>{children}</DialogContent>
      ) : (
        <DialogContent>
          <DialogContentText>{text}</DialogContentText>
        </DialogContent>
      )}
      <DialogActions>
        {isFullScreen && (
          <Button
            className="position-absolute"
            style={{ bottom: '5px', right: 0 }}
            onClick={() => setFullScreen(!fullScreen)}
          >
            {fullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
          </Button>
        )}

        <Button
          onClick={() => handleClose(false)}
          variant="text"
          color="default"
          disabled={inProgress}
        >
          {no}
        </Button>
        {!inProgress && !loadingButton ? (
          <Button
            onClick={handleClose}
            variant={variant}
            autoFocus
            color="secondary"
          >
            {yes}
          </Button>
        ) : null}

        {loadingButton ? (
          <ProgressiveButton
            startIcon
            endIcon={rest.endIcon}
            onClick={handleClose}
            variant={variant}
            autoFocus
            color="secondary"
            disabled={inProgress}
          >
            {yes}
          </ProgressiveButton>
        ) : null}
      </DialogActions>
    </Dialog>
  );
});
